import React from 'react';
import LateralMenu from './LateralMenu';
import { translate } from '../services/translate';
import { useCurrentApp } from '../context/CurrentApp';
import { Module } from '../Routes';

export default function GenericLateralMenu({ navigation, open, authenticatedUser, setOpen, selectedMenu, moduleObj }: LateralMenuProps & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    moduleObj: Module<any>;
}) {
    const currentApp = useCurrentApp();
    const items = [];

    for (const screenObj of Object.values(moduleObj.screens)) {

        if (screenObj.accessInformation) {
            items.push({
                icon: screenObj.accessInformation.icon,
                selected: selectedMenu === screenObj.selectedItem,
                text: translate(screenObj.label),
                action: () => screenObj.accessInformation!.navigate(navigation),
                omit: !screenObj.canAccess(authenticatedUser, currentApp),
            });
        }
    }

    return (
        <LateralMenu
            topImage={!moduleObj.hideFromMenu ? moduleObj.logo : undefined}
            collapsedTopImage={!moduleObj.hideFromMenu ? moduleObj.icon : undefined}
            open={open}
            setOpen={setOpen}
            authenticatedUser={authenticatedUser}
            items={items}
        />
    );
}
